import React from "react";
import { Link } from 'react-router-dom'

export default function ContainerProjetos({ title, bgImage, link }) {
    return (
        <Link to={link}>
            <div className='container-projetos'>
                <img alt="" src={bgImage} />
                <div className="texto-content">
                    <h3>{title}</h3>
                    <h4>Website</h4>
                </div>

            </div>
        </Link>
    )
}